import { useContext } from 'react';
import { IQualificationsOpenStepsContext, QualificationsOpenStepsContext } from '../contexts';

export const useQualificationsOpenSteps: () => IQualificationsOpenStepsContext = () => {
  return useContext(QualificationsOpenStepsContext);
};
